export default __webpack_public_path__ + "static/media/report.1b3b15ed.svg";